export enum ProfileOrgIndEnum {
  Organization = 0,
  Individual = 1,
}
